import { Span, type SpanProps } from "@hopper-ui/styled-system";

export function Section(props: SpanProps) {
    return (
        <Span
            fontSize="overline"
            fontWeight="overline"
            lineHeight="overline"
            color="neutral-weak"
            textTransform="uppercase"
            fontFamily="overline"
            UNSAFE_letterSpacing="0.015rem"
            data-public
            {...props}
        />
    );
}
